<template>
    <div class='container'>
        <h3 class='text text-center'>互联网房屋租赁平台服务公约</h3>
        <convention-catalogue :convention='convention'/>
        <hr>
        <convention-content :convention='convention'/>
    </div>
</template>

<script>
    import { CONVENTION_CONTENT } from '@/clause/regulation/platform.convention'
    import ConventionCatalogue from './_catalogue'
    import ConventionContent from './_content'

    export default {
        components: {
            ConventionCatalogue,
            ConventionContent
        },
        data () {
            return {
                convention: CONVENTION_CONTENT
            }
        }
    }
</script>

